import * as React from 'react';
import { Dialog, DialogType, DialogFooter, DialogContent } from '@fluentui/react/lib/Dialog';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { useBoolean } from '@fluentui/react-hooks';
import { TextField, MaskedTextField } from '@fluentui/react/lib/TextField';
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Text } from "@fluentui/react";

const modalPropsStyles = { main: { maxWidth: '50rem' } };
const dialogContentProps = {
  type: DialogType.normal,
  title: 'Deactivated licenses',
  subText: 'Some licenses have been deactivated.',
};

export const HasDeactivatedLicenseDialog = (props) => {
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const {showHasDeactivatedLicensesDialog, setShowHasDeactivatedLicensesDialog,} = props;

  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: false,
    }),
  );

  
  function onCloseDialog() {
    if(showHasDeactivatedLicensesDialog == true) {
      setShowHasDeactivatedLicensesDialog(false);
    }
}


  return (
    <>
      <Dialog
        hidden={!showHasDeactivatedLicensesDialog}
        onDismiss={onCloseDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
          <DialogContent>
            <Text>Some licenses have been deactivated. Please consider buying additional licenses if needed, or make changes to your assigned licenses accordingly.</Text>
          </DialogContent>
        <DialogFooter>
          <PrimaryButton onClick={onCloseDialog} text="Ok" />
        </DialogFooter>
      </Dialog>
    </>
  );
};
